import { useContext } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { AnalyticsContext } from "../contexts/AnalyticsContext";
import { getPersonalInfo } from "../redux/slices/PersonalAccountInformationSlice";
import { identifyEvent, trackEvent } from "../utils/segmentAnalytics";

const useSegmentTrack = () => {
  const analytics = useContext(AnalyticsContext);
  const { t } = useTranslation();
  const personalInfo = useSelector((state) => getPersonalInfo(state));

  const trackEventWithIndentity = async ({
    eventName,
    traits = {},
    props = {},
    replaceUndefinedOrNullValues = true,
  }) => {
    try {
      await identifyEvent({
        traits,
        userId: personalInfo?.id,
        analytics,
        replaceUndefinedOrNullValues,
        user: personalInfo,
      });
      await trackEvent({
        eventNameKey: eventName,
        analytics,
        props,
        user: personalInfo,
      });
    } catch (err) {
      console.error(`${t("errorInTrackEventWithIndentity")}, ${err}`);
    }
  };

  const trackEventWithoutIndentity = async ({ eventName, props = {} }) => {
    try {
      await trackEvent({
        eventNameKey: eventName,
        analytics,
        props: { ...props, userId: personalInfo?.id },
        userId: personalInfo?.id,
      });
    } catch (err) {
      console.error(`${t("errorInTrackEventWithoutIndentity")}, ${err}`);
    }
  };

  return { analytics, trackEventWithIndentity, trackEventWithoutIndentity };
};

export default useSegmentTrack;
